import { render, staticRenderFns } from "./FormDadosCobranca.vue?vue&type=template&id=fdb1050c"
import script from "./FormDadosCobranca.vue?vue&type=script&lang=ts"
export * from "./FormDadosCobranca.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports